<template lang="html">
  <div class="fillIn-panel">
    <div class="fillIn-panel-warp">
      <div class="form-panel">
        <div class="form-panel-row">
          <span class="form-panel-col-head">联系方式</span>
          <div class="form-panel-col-value border-all">
            <input
              type="tel"
              placeholder="您的手机号"
              v-model="collectInfo.contactPhone"
              maxlength="11"
            />
          </div>
          <div class="form-panel-col-tip">*</div>
        </div>
        <div class="form-panel-row">
          <span class="form-panel-col-head">选择城市</span>
          <div
            class="form-panel-col-value border-all"
            :class="{ hasplaceholder: !collectCity.cityName }"
            @click="selectCity"
          >
            <span>{{
              collectCity.cityName ? collectCity.cityName : '请选择您所在的城市'
            }}</span>
          </div>
          <!-- <div class="form-panel-col-value border-all">
                    <select v-model="collectInfo.cityCode" :class="{'disable-text': !collectInfo.cityCode}">
                        <option value='' disabled selected>请选择城市</option>
                        <option v-for="(item, index) in supportCollectCityList" :value="item.cityCode">{{item.cityName}}</option>
                    </select>
                </div> -->
          <div class="form-panel-col-tip">*</div>
        </div>
        <div class="form-panel-row" v-if="collectInfo.cityCode != 100">
          <span class="form-panel-col-head">选择门店</span>
          <div
            class="form-panel-col-value border-all"
            :class="{ hasplaceholder: !collectStore.store_desc }"
            @click="selectStore"
          >
            <span>{{
              collectStore.store_desc
                ? collectStore.store_desc
                : '请选择您所附近的门店'
            }}</span>
          </div>
          <!-- <div class="form-panel-col-value border-all">
                    <select v-model="collectInfo.storeCode" :class="{'disable-text': !collectInfo.storeCode}">
                        <option value='' disabled selected>选择附近门店</option>
                        <option v-for="(item, index) in storeList" :value="item.departmentNo">{{item.store_desc}}</option>
                    </select>
                </div> -->
          <div class="form-panel-col-tip">*</div>
        </div>
        <div class="form-row-time">
          <span class="form-panel-col-head">预产期</span>
          <div class="form-panel-col-value">
            <ul>
              <li
                v-for="(item, index) in times"
                @click="selectTime(item, index)"
                :class="{ select: index === selectdTimeIndex }"
              >
                {{ item.label }}
              </li>
            </ul>
          </div>
        </div>
        <div class="form-panel-row">
          <span class="form-panel-col-head">您的称呼</span>
          <div class="form-panel-col-value border-all">
            <input
              type="text"
              placeholder="填写您的称呼（选填）"
              v-model="collectInfo.contactName"
              maxlength="16"
            />
          </div>
        </div>
      </div>
      <button @click="submit">立即预约</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import storage from '@/plugins/localStorage'

export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      times: [],
      info: {},
      isShow: true,
      storeList: [],
      selectdTimeIndex: 0
    }
  },
  async created() {
    /* eslint-disable*/
        let i = 0
        while (i < 6) {
            const time = new Date()
            time.setMonth(time.getMonth() + i, 1)
            const month = `${time.getFullYear()}-${(time.getMonth() + 1).toString().padStart(2, '0')}`
            const timeObj = { label: month, value: month }
            if (this.collectInfo.dueDate && timeObj.value === this.collectInfo.dueDate) {
                timeObj.selected = true
            }
            this.times.push(timeObj)
            i += 1
        }
        this.collectInfo.childbirthDate = this.times[0].label
        if (this.supportCollectCityList.length > 0) {
            this.getStoreList(this.supportCollectCityList[0].cityCode)
        }
    },
    methods: {
        ...mapMutations(['setViewNameList', 'setActionHeader']),
        clickField(eventId) {
            this.$$tracker('210101', '20000', eventId)
        },
        selectCity() {
            this.isShow = false
            this.setViewNameList('fillInCityForm')
            this.setActionHeader({
                title: '所在城市',
                show: false
            })
        },
        selectStore() {
            if (!this.collectCity.cityCode) {
                return this.$$toast('请先选择城市')
            }
            this.isShow = false
            this.setViewNameList('fillInStoreForm')
            this.setActionHeader({
                title: '附近门店',
                show: false
            })
        },
        // changeCity(e) {
        //     this.collectInfo.storeCode = ''
        //     this.collectInfo.storeName = ''
        //     const city = this.supportCollectCityList.filter(v => v.cityCode === this.collectInfo.cityCode)
        //     if (city && city.length > 0) {
        //         this.collectInfo.cityName = city[0].cityName
        //     }
        //     this.getStoreList(this.collectInfo.cityCode)
        // },
        // changeStore() {
        //     const store = this.storeList.filter(v => v.departmentNo === this.collectInfo.storeCode)
        //     if (store && store.length > 0) {
        //         this.collectInfo.storeName = store[0].store_desc
        //     }
        // },
        async getStoreList(citycode) {
            const json = await this.$store.dispatch('getStoreListByCitycode', { city_code: citycode })
            this.storeList = json.data || []
        },
        selectTime(item, index) {
            this.$$tracker('210101', '20000', '21249', item.label)
            this.selectdTimeIndex = index
            this.collectInfo.childbirthDate = item.label
        },
        async submit() {
            this.$$tracker('210101', '20000', '21253')
            if (!this.collectCity.cityCode) {
                return this.$$toast('请选择您所在的城市')
            }
            if (!this.collectInfo.contactPhone) {
                return this.$$toast('请输入您的联系电话')
            }
            if (!/^1\d{10}/.test(this.collectInfo.contactPhone)) {
                return this.$$toast('请输入正确的联系电话')
            }
            if (this.collectCity.cityCode * 1 !== 100 && !this.collectStore.departmentNo) {
                return this.$$toast('请选择您附近的门店')
            }
            if (this.collectInfo.contactName && this.collectInfo.contactName.length > 20) {
                return this.$$toast('您的称呼应为20个字符以内')
            }
            if (this.collectInfo.contactName && !/^[\u4e00-\u9fa5]+$/g.test(this.collectInfo.contactName)) {
                return this.$$toast('称呼应全部为中文')
            }
            this.collectInfo.cityCode = this.collectCity.cityCode
            this.collectInfo.cityName = this.collectCity.cityName
            this.collectInfo.storeCode = this.collectStore.departmentNo
            this.collectInfo.storeName = this.collectStore.store_desc
            this.collectInfo.appointSkuCode = this.collectSkuInfo.skuCode
            this.collectInfo.appointSkuName = this.collectSkuInfo.skuName
            this.collectInfo.source = this.$$isHZWApp()? 1 : 2 // 1:特卖，2 微信
            const info_res = await this.$store.dispatch('saveCollectBasicInfo', { info: this.collectInfo })
            this.$$toast('您的信息已提交')
        }
    },
    computed: {
        ...mapState(['collectSkuInfo', 'supportCollectCityList', 'collectInfo', 'collectStore', 'collectCity']),
    },
    components: {
        // pageAction,
        // collectCitySheet
    }
}
</script>
<style lang="scss">
::-webkit-input-placeholder{
    color:#999 !important;
}
.action-title .title {
    font-weight: 400 !important;
}
</style>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.fillIn-panel{
    margin-left:rem(24px);
    margin-right:rem(24px);

    .form-panel{
        margin-top:rem(10px);

        .form-panel-row{
            height:rem(100px);
            display: flex;
            align-items: center;

            .form-panel-col-head{
                font-size: rem(28px);
                color:#666;
                width: rem(156px);
            }
            .border-all{
                @include border(all);
            }
            .form-panel-col-value {
                font-size: rem(28px);
                color:#121212;
                height: rem(60px);
                width: rem(546px);
                position: relative;
                display: flex;
                align-items: center;

                span{
                    padding-left: rem(20px);
                }
                input, select {
                    width:100%;
                    line-height: rem(60px);
                    margin-left: rem(20px);
                    appearance:none;
                    -moz-appearance:none;
                    -webkit-appearance:none;
                }
                select {
                    background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAAG+Fv5aAAAAAXNSR0IArs4c6QAAAMpJREFUGBljNDY2nsDAwJDPCGT8BzIgAMh5DRNAkWEEyYNk2NjYVMEcExOTY////7eE6gRTQEkuZD5Ix19TU9MgmCCKmTBBKD2RCUM7UIaRkfH42bNnC8B2Wlpaqvz69es2VMcboIQoiikgu0B2IgsyNjQ0MG3ZsmU10LVwhyArQGcDrVzn4+MTCrYSJAk0UQRIHQdiFRAfC7gDFLMEOucNSA6uEabQzMzM8t+/f3uBLuAEK2Bk/M7ExOR86tQpkKGEATCwC0AYl0oAUoQ/ApUf9nIAAAAASUVORK5CYII=") no-repeat 94% center transparent;
                    background-size: 4%;
                }
            }
            .form-panel-col-value.hasplaceholder{
                color:#999 !important
            }
        }
        .form-panel-col-tip{
            font-size: rem(28px);
            color: #FF397E;
            padding-left: rem(9px);
        }
        .form-row-time{
            height:rem(170px);
            display: flex;
            padding-top: rem(20px);

            .form-panel-col-head{
                font-size: rem(28px);
                color:#666;
                width: rem(156px);
                line-height: rem(60px);
            }
            .form-panel-col-value{
                font-size: rem(28px);
                color:#121212;
                width: rem(546px);
                position: relative;
            }
            ul{
                display: flex;
                flex-wrap: wrap;

                li{
                    width: rem(160px);
                    height: rem(60px);
                    background: #fff;
                    border-radius: rem(4px);
                    margin-right: rem(20px);
                    font-size: rem(28px);
                    color: #666666;
                    line-height: rem(60px);
                    text-align: center;
                    margin-bottom: rem(14px);
                    @include border(all, #ccc);
                }
                li.select{
                    background: #FFF3F7;
                    color: #FF397E;
                    @include border(all, #FF6EA2);
                }
            }
        }
    }
    .disable-text{
        color:#999;
    }
    button{
        width:100%;
        height:rem(100px);
        background-color: #ff6ea2;
        color:#fff;
        font-size: rem(32px);
        text-align: center;
        line-height: rem(100px);
        margin-top:rem(10px);
    }
}
</style>
